import styled from 'styled-components';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import { themeSpace } from 'styles/themeUtils';

export const Title = styled(Typography)`
  margin-top: ${themeSpace(3)};
`;

Title.defaultProps = {
  variant: 'subtitle',
  tag: 'h2',
};

export const Header = styled.header`
  position: relative;
`;
